import { render, staticRenderFns } from "./dev-stat.vue?vue&type=template&id=25e1a834&scoped=true"
import script from "./dev-stat.vue?vue&type=script&lang=js"
export * from "./dev-stat.vue?vue&type=script&lang=js"
import style0 from "./dev-stat.vue?vue&type=style&index=0&id=25e1a834&prod&lang=less&scoped=true"
import style1 from "./dev-stat.vue?vue&type=style&index=1&id=25e1a834&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e1a834",
  null
  
)

export default component.exports